import React, {Component} from 'react';


import {locale} from '../../locale/AppLocale';
import axios from 'axios'
import Config from '../../Helpers/Config';
import {GetEntityAttribute} from "../../Helpers/Entity";

export default class Categories extends  Component{

    constructor(props){
        super(props)
        this.state = {
            categories:[]
        }
    }

    componentDidMount(){
        this.fetchCategories()
    }

    render(){

        if(this.props.data.length === 0){
            return null
        }
        return (
            <div className="panel-1">
                <div className="panel-1--head">
                    {locale.get('select_upload_category')}
                </div>

                <div className="panel-1--body">
                    {this.state.categories.map((category,index) => {
                        return (
                            <button
                                onClick={() => {
                                    if(category.is_leaf){
                                        this.props.onChange(category)
                                    }else{
                                        this.fetchCategories(category.id)
                                    }
                                }}
                                className="category-pick--link category-pick--has-icon btn-2" key={index}>
                                <i className={category.category_class} /> <span className="title">{GetEntityAttribute(category,'title')}</span>
                            </button>
                        )
                    })}
                </div>
            </div>
        )
    }

    fetchCategories(parentId){
        let url = Config.api() + 'search/category-list';
        if(parentId){
            url += '/' + parentId;
        }

        return axios.get(url,{
            withCredentials:Config.withCredentials()
        })
        .then((response) => {

            this.setState({
                categories:response.data.categories
            })

        }).catch((error) => {
            console.log(error)
        });
    }
}
